import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: space-between;
  align-self: stretch;
  color: var(--white);
  background: var(--luft-secondary);
  width: 100%;
  height: 100%;
  padding: 24px 24px 0 24px;
  gap: 24px;
`;

export const FirstLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  font-size: 24px;
  line-height: 32px;
  font-weight: normal;
`;

export const SecondLine = styled.div`
  display: flex;
  gap: 24px;
`;

export const FiltersContainer = styled.div`
  flex: 2;
`;
